import { render, staticRenderFns } from "./ClientsOnHoldTab.vue?vue&type=template&id=6310655a&scoped=true&"
import script from "./ClientsOnHoldTab.vue?vue&type=script&lang=js&"
export * from "./ClientsOnHoldTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientsOnHoldTab.vue?vue&type=style&index=0&id=6310655a&prod&lang=scss&scoped=true&"
import style1 from "./ClientsOnHoldTab.vue?vue&type=style&index=1&id=6310655a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310655a",
  null
  
)

export default component.exports